export const STATUS_CODES = {
  SUCCESS: 200,
  NO_RECORDS: 404,
  UN_AUTH: 401,
  FORBIDDEN: 403,
  BAD_REQUEST: 400,
};
